import React, { useMemo, useState, useEffect } from 'react';
import { getReapplicants } from 'services/ReappLoanService';
import LoanDetails from './LoanDetails';
import { TableContainer } from 'components/Dashboard/Loan/style';
import { REAPPLICANT_COLUMN } from './columns';
import { Table } from 'antd';
import ReapplicantForm from './ReapplicantForm';
import { Link } from 'react-router-dom';
import { DASHBOARD_RE_APPLICANT_ROUTE } from 'routes';



const useGetReapplicants = ()=>{
  const [reapplicantLoans,setReapplicantLoans] = useState([])
  const [loading,setLoading] = useState(true)

  const refetch = useMemo(()=>{
    return async function(){
      try {
        const [res,err] = await getReapplicants()
        if(!err){
          setReapplicantLoans(res.data.reapplicants)
          return;
        }
      } finally{
        setLoading(false)
      }
    }
  },[])

  useEffect(()=>{
    refetch()
  },[refetch])

  return {
    loading,
    reapplicantLoans,
    refetch,
  }

}

const ReappUpload = () => {
  const [loanFormShowing,setLoanFormShowing] = useState(false);

  const openModal = () => { setLoanFormShowing(true); };
  const closeMoal = () => { setLoanFormShowing(false); };

  const [selectedLoanId, setSelectedLoanId] = useState(null);

  const {loading,reapplicantLoans} = useGetReapplicants()




  return (
    <>
      <ReapplicantForm open={loanFormShowing} closeModal={closeMoal}/>
      <header className="flex items-center my-4">
         <div></div>
         <Link to={`${DASHBOARD_RE_APPLICANT_ROUTE}/add`}>
          <button onClick={openModal} className="ml-auto bg-primary text-white px-7 py-2 rounded-md">Add Reapplicant Record</button>
         </Link>
      </header>
      <TableContainer>
        <Table  scroll={{ x: 'max-content' }}
          columns={REAPPLICANT_COLUMN}
          loading={loading}
          dataSource={reapplicantLoans}
          />
      </TableContainer>
      {selectedLoanId && <LoanDetails loanId={selectedLoanId} onClose={() => setSelectedLoanId(null)} />}
	  
    </>
  );
};

export default ReappUpload;
